module.exports = {
    apiBaseUrl: "https://nurse-dc-gateway-test-0-61mvzxr6.wl.gateway.dev",
    // apiBaseUrl: "http://localhost:8000",
    auth0: {
        domain: "meruproductions.us.auth0.com",
        clientId: "oFQUE2pxMiGK9scj6dltRKFfDF7jBZKq",
        audience: "https://meruproductions.us.auth0.com/api/v2/"
    }
}